let c1011 = document.querySelector('.C1011')

let faqCategories = c1011.querySelectorAll('[data-faq-category]')
let faqCategoriesQuestions = c1011.querySelectorAll('[data-faq-category-faqs]');

faqCategories.forEach((category)=> {
    category.addEventListener('click', ()=>{

        faqCategories.forEach((category)=> {
            category.classList.remove('active');
        })

        faqCategoriesQuestions.forEach((questions)=> {
            if (questions.dataset.faqCategoryFaqs === category.dataset.faqCategory) {
                questions.classList.remove('h-0','opacity-0');
                questions.classList.add('animate-fadeUp');
            } else {
                questions.classList.add('h-0','opacity-0');
                questions.classList.remove('animate-fadeUp');
            }
        })

        category.classList.add('active');
    })
})

faqCategories[0].click();